export class ForkliftFeeCheckbox {
	/**
	 * Constructor.
	 *
	 * @param {HTMLInputElement} element The checkbox element.
	 */
	constructor( element ) {
		this.element = element;
		this.checkboxElement = this.element.querySelector( 'input[type="checkbox"]' );
	}

	/**
	 * Initializes the component.
	 *
	 * @return {void}
	 *
	 * @public
	 */
	init() {
		// The only reason this is jQuery is cause we have to trigger the update_checkout event
		// which is a WooCommerce event.
		jQuery( 'form.checkout' ).on( 'change', 'input[name=has_forklift]', () => {
			if ( ! this.isCheckboxEnabled() ) {
				return;
			}

			jQuery( 'body' ).trigger( 'update_checkout' );
		} );

		jQuery( 'body' ).on( 'update_checkout', () => {
			this.disableCheckbox();
		} );

		jQuery( 'body' ).on( 'updated_checkout', () => {
			this.enableCheckbox();
		} );
	}

	/**
	 * Make the checkbox disabled.
	 *
	 * @return {void}
	 *
	 * @private
	 */
	disableCheckbox() {
		this.element.classList.add( 'disabled' );
	}

	/**
	 * Make the checkbox enabled.
	 *
	 * @return {void}
	 *
	 * @private
	 */
	enableCheckbox() {
		this.element.classList.remove( 'disabled' );
	}

	/**
	 * Check if the checkbox is enabled.
	 *
	 * @return {boolean} Checks if the checkbox is enabled.
	 *
	 * @private
	 */
	isCheckboxEnabled() {
		return ! this.element.classList.contains( 'disabled' );
	}
}
